export const ContactType = {
    PHONE: {
        serviceType: "PHONE",
        title: "전화",
        iconPath: "/assets/icons/social/phone.svg",
        placeholder: "-없이 전화번호만 입력해주세요"
    },
    KAKAOTALK: {
        serviceType: "KAKAOTALK",
        title: "카카오톡",
        iconPath: "/assets/icons/social/kakaotalk.svg",
        placeholder: "아이디를 입력해주세요"
    },
    EMAIL: {
        serviceType: "EMAIL",
        title: "이메일",
        iconPath: "/assets/icons/social/email.svg",
        placeholder: "메일 주소를 입력해주세요"
    },
    INSTAGRAM: {
        serviceType: "INSTAGRAM",
        title: "인스타그램",
        iconPath: "/assets/icons/social/instagram.svg",
        link: (id) => `https://www.instagram.com/${id}`,
        placeholder: "아이디를 입력해주세요"
    },
    FACEBOOK: {
        serviceType: "FACEBOOK",
        title: "페이스북",
        link: (id) => `${id}`,
        iconPath: "/assets/icons/social/facebook.svg",
        placeholder: "프로필 웹 주소를 입력해주세요"
    },
    TWITTER: {
        serviceType: "TWITTER",
        title: "트위터",
        iconPath: "/assets/icons/social/twitter.svg",
        link: (id) => `https://twitter.com/${id}`,
        placeholder: "아이디를 입력해주세요"
    },
    WEB: {
        serviceType: "WEB",
        title: "웹사이트",
        iconPath: "/assets/icons/social/web.svg",
        link: (url) => url,
        placeholder: "웹 주소를 입력해주세요"
    },
    NOTION: {
        serviceType: "NOTION",
        title: "노션",
        iconPath: "/assets/icons/social/notion.svg",
        link: (url) => url,
        placeholder: "공유할 주소를 입력해주세요"
    },
    LINKEDIN: {
        serviceType: "LINKEDIN",
        title: "링크드인",
        iconPath: "/assets/icons/social/linkedin.svg",
        link: (id) => `https://www.linkedin.com/in/${id}`,
        placeholder: "아이디를 입력해주세요"
    }
}